module.exports = __webpack_public_path__ + "media/src/assets/animation-be3cca72dafed29d4ea6cdec36b11ea4.gif";